export default Array.from;
